export default Array.from;
